import type { PerlinIslandsNoiseOptions } from '../noise/perlinIslands';

function createSingleLargeIslandPreset(mapRadius: number): PerlinIslandsNoiseOptions {
  return {
    frequency: 0.075,
    octaves: 3,
    persistence: 0.48,
    lacunarity: 2,
    islandRadius: mapRadius * 0.98,
    coastlineFalloff: 2.8,
    seaLevel: 0.18,
    noiseWeight: 0.45,
    maskWeight: 1.3,
    heightOffset: 0.06,
    beachLevel: 0.07,
    fertilityFrequency: 0.18,
    fieldThreshold: 0.04,
    woodlandFrequency: 0.16,
    forestThreshold: 0.12,
  };
}

function createLotsOfSmallIslandsPreset(mapRadius: number): PerlinIslandsNoiseOptions {
  return {
    frequency: 0.2,
    octaves: 5,
    persistence: 0.6,
    lacunarity: 2.2,
    islandRadius: mapRadius * 1.5,
    coastlineFalloff: 1.15,
    seaLevel: 0.24,
    noiseWeight: 1.2,
    maskWeight: 0.34,
    heightOffset: 0,
    beachLevel: 0.05,
    fertilityFrequency: 0.22,
    fieldThreshold: 0.04,
    woodlandFrequency: 0.2,
    forestThreshold: 0.12,
  };
}

export { createLotsOfSmallIslandsPreset, createSingleLargeIslandPreset };
